import type { VatDetails } from '../types/VatReturn';
import { useState } from 'react';
import { useForm } from '@mantine/form';
import { validateDate, validateEndDate } from '../../../util/validation/commonValidation';

const defaultVatDetails: VatDetails = {
	registrationNumber: '',
	vatScheme: '',
	startDate: undefined,
	endDate: undefined,
	deadline: null,
	periodType: '',
};

export function useReturnDetailsForm(currentInputs?: VatDetails) {
	const [inputs, setInputs] = useState<VatDetails>(
		currentInputs ?? defaultVatDetails,
	);
	const form = useForm<VatDetails>({
		mode: 'uncontrolled',
		initialValues: currentInputs ?? defaultVatDetails,
		validate: {
			registrationNumber: (v) => {
				if (!/^GB\s?\d{3}\s?\d{2}\s?\d{2}\s?\d{2}$/.test(v)) {
					return 'Invalid registration number';
				}
			},
			vatScheme: (v) => (v == null || v === '') && 'Select VAT scheme',
			periodType: (v) => (v == null || v === '') && 'Select period covered',
			startDate: (value) => validateDate(value, false),
			endDate: (value, values) =>
				validateEndDate(value, false, values.startDate),
			deadline: (v) => v === null && 'Select deadline',
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
